// automatically generated by the FlatBuffers compiler, do not modify

import { flatbuffers } from "flatbuffers";
/**
 * @constructor
 */
export namespace RockIt{
export class Vec3 {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  bb: flatbuffers.ByteBuffer;

  /**
   * @type {number}
   */
  bb_pos: number = 0;
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Vec3}
 */
__init(i: number, bb: flatbuffers.ByteBuffer): Vec3 {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

/**
 * @returns {number}
 */
x(): number {
  return this.bb.readFloat32(this.bb_pos);
}

/**
 * @returns {number}
 */
y(): number {
  return this.bb.readFloat32(this.bb_pos + 4);
}

/**
 * @returns {number}
 */
z(): number {
  return this.bb.readFloat32(this.bb_pos + 8);
}

/**
 * @param {flatbuffers.Builder} builder
 * @param {number} x
 * @param {number} y
 * @param {number} z
 * @returns {flatbuffers.Offset}
 */
static createVec3(builder: flatbuffers.Builder, x: number, y: number, z: number): flatbuffers.Offset {
  builder.prep(4, 12);
  builder.writeFloat32(z);
  builder.writeFloat32(y);
  builder.writeFloat32(x);
  return builder.offset();
}

}
}
/**
 * @constructor
 */
export namespace RockIt{
export class Transform {
  /**
   * @type {flatbuffers.ByteBuffer}
   */
  bb: flatbuffers.ByteBuffer;

  /**
   * @type {number}
   */
  bb_pos: number = 0;
/**
 * @param {number} i
 * @param {flatbuffers.ByteBuffer} bb
 * @returns {Transform}
 */
__init(i: number, bb: flatbuffers.ByteBuffer): Transform {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

/**
 * @param {flatbuffers.ByteBuffer} bb
 * @param {Transform=} obj
 * @returns {Transform}
 */
static getRootAsTransform(bb: flatbuffers.ByteBuffer, obj?: Transform): Transform {
  return (obj || new Transform).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
position(obj?: RockIt.Vec3): RockIt.Vec3|null {
  let offset = this.bb.__offset(this.bb_pos, 4);
  return offset ? (obj || new RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
}

/**
 * @param {RockIt.Vec3=} obj
 * @returns {RockIt.Vec3|null}
 */
rotation(obj?: RockIt.Vec3): RockIt.Vec3|null {
  let offset = this.bb.__offset(this.bb_pos, 6);
  return offset ? (obj || new RockIt.Vec3).__init(this.bb_pos + offset, this.bb) : null;
}

/**
 * @param {flatbuffers.Builder} builder
 */
static startTransform(builder: flatbuffers.Builder) {
  builder.startObject(2);
}

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} positionOffset
 */
static addPosition(builder: flatbuffers.Builder, positionOffset: flatbuffers.Offset) {
  builder.addFieldStruct(0, positionOffset, 0);
}

/**
 * @param {flatbuffers.Builder} builder
 * @param {flatbuffers.Offset} rotationOffset
 */
static addRotation(builder: flatbuffers.Builder, rotationOffset: flatbuffers.Offset) {
  builder.addFieldStruct(1, rotationOffset, 0);
}

/**
 * @param {flatbuffers.Builder} builder
 * @returns {flatbuffers.Offset}
 */
static endTransform(builder: flatbuffers.Builder): flatbuffers.Offset {
  let offset = builder.endObject();
  return offset;
}

}
}



// WEBPACK FOOTER //
// ./src/common/component/transform_generated.ts